module.exports = __webpack_public_path__ + "img/doll liberation front.29f21933.png";